<template>
  <div class="animated fadeIn bike">
    <h1 class="title">Indoor cycling</h1>
    <b-row>
        <b-col lg="12" v-if="!selectedItem.user">
          <c-table
            :table-data="items"
            hover striped bordered small fixed
            :fields="fields" @on-select="onSelectItem"
            :caption="$t('messages.lastIndoorSessions')"
          ></c-table>
        </b-col>

        <b-col lg="12" v-show="selectedItem.user">
          <dash :selectedItem="selectedItem" @on-cancel="selectedItem.user = null" @on-prev="onPrev" @on-next="onNext"></dash>
        </b-col>
    
    </b-row>
  </div>
</template>

<script>

import cTable from "./utils/Table.vue";
import dash from "./spinning/Spinning-dashboard.vue";

export default {
  name: "spinning",
  components: {
    cTable,
    dash
  },
  data() {
    return {
      items: [],
      //selectedItem: null,
      selectedItem : {
       
      },
      fields: [
        { key: "insertAt", label: "Date "},
        { key: "distance", label: " Total distance"},
        { key: "time", label: " Session duration"},
        { key: "energy", label: " Energy"},
        { key: "avgspeed", label: " Average speed"},
        { key: "avgrpm", label: "Average RPM"},
        { key: "maxpower", label: "Max power"},
        { key: "hrmax", label: "HR Max."},
        { key: 'actions', label: 'Actions' }
      ]
    };
  },
  mounted(){
      this.$nextTick( () =>{
        this.$store.dispatch("fetchSpinningData",{ orderBy:[{directionStr:'desc'}], limit: 50}).then(sessions => {
            this.items = sessions
            }, error => {
            console.error('No user data', error)
        })
      })
  },
  methods:{
    onSelectItem(item){
      let d = Object.assign({}, item)
      this.selectedItem = d
      let index = this.items.findIndex(x => x === item);
      this.selectedIndex = index
    },
    onPrev(){
      let index = this.selectedIndex - 1
      if(this.items[index]){
        this.selectedItem = Object.assign({}, this.items[index])
        this.selectedIndex = index
      }
    },
    onNext(){
      let index = this.selectedIndex + 1
      if(this.items[index]){
        this.selectedItem = Object.assign({}, this.items[index])
        this.selectedIndex = index
      }
    }
  }
};
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>




// WEBPACK FOOTER //
// src/components/Spinning.vue